import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Configure dayjs for timezone support
dayjs.extend(utc);
dayjs.extend(timezone);

const HeroSection = ({ eventData, activityType, activityId }) => {
  return (
    <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{ backgroundImage: `url(${eventData?.imageUrl})` }}
      />
      {/* Professional gradient overlay with warmth */}
      <div className="absolute inset-0 bg-gradient-to-b from-orange-900/30 via-pink-900/20 to-purple-900/40 z-10" />

      <div className="relative z-20 text-center max-w-5xl mx-auto px-6 py-12">
        <div className="bg-white/95 backdrop-blur-sm rounded-lg p-8 md:p-12 shadow-2xl border border-orange-200">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-orange-600 via-pink-500 to-purple-600 bg-clip-text text-transparent leading-tight">
            {eventData.name}
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl font-medium mb-8 text-slate-700 leading-relaxed max-w-3xl mx-auto">
            {eventData.description}
          </p>

          <div className="inline-flex items-center gap-2 text-base sm:text-lg mb-10 text-white font-semibold bg-gradient-to-r from-orange-500 to-pink-500 rounded-lg px-6 py-3 shadow-md">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            {dayjs(eventData.startAt).tz('Asia/Jakarta').format('dddd, DD MMMM YYYY')}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href={`/${activityType}/${activityId}/register`}
              className="group inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-gradient-to-r from-orange-500 to-pink-500 rounded-lg shadow-lg hover:from-orange-600 hover:to-pink-600 hover:shadow-xl transform hover:scale-105 transition-all duration-200 min-w-[200px]"
              role="button"
              aria-label="Register for this event"
            >
              <span className="flex items-center gap-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                </svg>
                Register Now
              </span>
            </a>

            <a
              href={`/${activityType}/${activityId}/login`}
              className="group inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-purple-600 bg-white border-2 border-purple-500 rounded-lg shadow-lg hover:bg-purple-50 hover:border-purple-600 hover:shadow-xl transform hover:scale-105 transition-all duration-200 min-w-[200px]"
              role="button"
              aria-label="Login if already registered"
            >
              <span className="flex items-center gap-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                </svg>
                Already Registered?
              </span>
            </a>
          </div>

          <p className="text-sm text-slate-600 font-medium mt-6">
            Secure your spot at this exciting event
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;